import { useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";

export function CopyButton({
  text,
  label,
  className = "",
}: {
  text: string;
  /** The accessible name, e.g. "Copy value". */
  label: string;
  className?: string;
}) {
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (!done) return;
    const t = setTimeout(() => setDone(false), 1200);
    return () => clearTimeout(t);
  }, [done]);
  return (
    <button
      type="button"
      aria-label={label}
      title={done ? "Copied" : label}
      className={`inline-flex size-5 items-center justify-center rounded-[4px] text-faint hover:bg-chip
                  hover:text-ink ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        void navigator.clipboard?.writeText(text).then(() => setDone(true));
      }}
    >
      {done ? <Check size={12} strokeWidth={2.2} /> : <Copy size={12} strokeWidth={2} />}
    </button>
  );
}
